module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"option":{"placeholder":"Write option name here"},"add":"Create"}}')
  delete Component.options._Ctor
}
